import { render, staticRenderFns } from "./_purgeIBCTeam.vue?vue&type=template&id=5e8a6af2&scoped=true&lang=pug&"
import script from "./_purgeIBCTeam.vue?vue&type=script&lang=js&"
export * from "./_purgeIBCTeam.vue?vue&type=script&lang=js&"
import style0 from "./_purgeIBCTeam.vue?vue&type=style&index=0&id=5e8a6af2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e8a6af2",
  null
  
)

export default component.exports